const setElementSticky = (element, sticky = 0) => {
  if (element) {
    window.pageYOffset > sticky ? element.classList.add('sticky') : element.classList.remove('sticky');
  }
};

export default setElementSticky;
